<template>
    <div class="f-share" v-if="visible">
        <transition name="slideInUp" v-on:after-leave="slideInUpLeave">
            <div class="share-content" v-if="showContent">
                <div class="share-title">分享到</div>
                <div class="share-list-wrap">
                    <div class="share-list">
                        <div class="share-wrap"
                        v-for="(item, index) in shareItem"
                        :data-type="item.type"
                        :key="index"
                        v-on:click="onShareHandle">
                            <img :src="item.image" :alt="item.text">
                            <div class="text">{{ item.text }}</div>
                        </div>
                        <div class="share-wrap" v-for="i in 4 - shareItem.length" :key="i"></div>
                    </div>
                </div>
                <div class="share-cancle" :class="{'iPhoneX': isiPhoneX}" v-on:click="onCancleHandle">取消</div>
            </div>
        </transition>
        <div class="share-mask" v-on:click="onCancleHandle"></div>
    </div>
</template>

<script>
    import utils from '../utils'

    export default {
        name: 'f-share',
        data () {
            return {
                showContent: false,
                isiPhoneX: utils.isiPhoneX()
            }
        },
        props: {
            shareItem: {
                type: Array,
                default () {
                    return [
                        {image: '//cdn.upin.com/mfanhuan/images/faxian/ico_sharewx.png', text: '朋友圈', type: 'friend'},
                        {image: '//cdn.upin.com/mfanhuan/images/faxian/ico_sharewxf.png', text: '微信好友', type: 'weixin'},
                        {image: '//cdn.upin.com/mfanhuan/images/faxian/ico_shareqq.png', text: 'QQ好友', type: 'qq'},
                        {image: '//cdn.upin.com/mfanhuan/images/faxian/ico_sharesina.png', text: '新浪微博', type: 'weibo'}
                    ]
                }
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible (val) {
                this.$nextTick(function () {
                    this.showContent = val
                })
            }
        },
        methods: {
            onShareHandle (e) {
                var target = utils.closest(e.target, 'share-wrap')
                var type = target.getAttribute('data-type')

                this.$emit('share', {type: type})
                window.location.href = window.location.protocol + '//m.fanhuan.com/app/?sharechannel=' + type
            },
            onCancleHandle () {
                this.showContent = false
            },
            slideInUpLeave () {
                var self = this
                setTimeout(function () {
                    self.$emit('share-cancle')
                }, 300)
            }
        }
    }
</script>

<style lang="stylus">
    .slideInUp-enter-active
        animation: slideInUp .3s
    .slideInUp-leave-active
        animation: slideInUp .3s reverse
    @keyframes slideInUp
        from
            transform: translate3d(0, 100%, 0)
            visibility: visible
        to
            transform: translate3d(0, 0, 0)

    .f-share
        position: fixed
        left: 0
        width: 100%
        bottom: 0
        .share-content
            position: relative
            z-index: 10
            overflow: hidden
            background: #eff0f2
        .share-title
            font-size: 16px
            color: #666
            line-height: 58px
            padding: 0 25px
            background: #eff0f2
        .share-list-wrap
            padding: 0 25px
            background: #eff0f2
            .share-list
                padding: 0 0 25px
                background: #eff0f2
                display: -webkit-box
                display: -webkit-flex
                display: flex
                -webkit-box-pack: justify
                -webkit-justify-content: space-between
                justify-content: space-between
                -webkit-box-align: stretch
                -webkit-align-items: stretch
                align-items: stretch
                .share-wrap
                    width: 54px
                    display: -webkit-box
                    display: -webkit-flex
                    display: flex
                    -webkit-box-pack: center
                    -webkit-justify-content: center
                    justify-content: center
                    -webkit-box-align: center
                    -webkit-align-items: center
                    align-items: center
                    -webkit-box-lines: multiple
                    -webkit-flex-wrap: wrap
                    flex-wrap: wrap
                    img
                        width: 54px
                        height: 54px
                    .text
                        font-size: 12px
                        color: #666
                        text-align: center
                        margin-top: 11px
        .share-cancle
            line-height: 46px
            height: 46px
            background-color: #fff
            color: #333
            font-size: 18px
            text-align: center
            &:active
                background-color: #f0f0f0
        .share-cancle.iPhoneX
            padding-bottom: 37px
        .share-mask
            position: fixed
            left: 0
            right: 0
            top: 0
            bottom: 0
            background: rgba(0,0,0,.7)
            width: 100%
            height: 100%
            z-index: 1
</style>


// WEBPACK FOOTER //
// share.vue?566cffc0